<template>
  <div>
    <b-row>
      <b-col lg="6">
        <SelectWithSearch
          label="Class. trib. IBS/CBS"
          v-model="cClassTrib"
          :filterBy="taxFilter"
          :change="changeClassTribIBSCBSSelected"
          :options="classTribIBSCBSCollection"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Nenhum resultado encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col lg="6">
        <SelectWithSearch
          label="CST IBS/CBS"
          disabled
          v-model="cstIBSCBS"
          :filterBy="taxFilter"
          :options="CSTIBSCBSCollection"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Nenhum resultado encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col lg="3">
        <InputMoney
          label="Base de cálculo"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.vBC"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor do IBS"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.vIBS"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputMoney, SelectWithSearch } from '@/components/Form';

export default {
  name: 'IBSRegimeTaxes',
  components: {
    InputMoney,
    SelectWithSearch,
  },
  data() {
    return {
      cClassTrib: null,
      cstIBSCBS: null,
      taxFilter(option, _, search) {
        if (!search) return true;

        const searchToLower = search.toLowerCase();

        const codigoMatch = option.codigo
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);
        const descricaoMatch = option.descricao
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);

        return codigoMatch || descricaoMatch;
      },
    };
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
    ...mapState('ibsRegime', ['classTribIBSCBSCollection', 'CSTIBSCBSCollection']),
  },
  mounted() {
    const classTrib = this.classTribIBSCBSCollection.find(
      (e) => e.codigo === this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime?.cClassTrib,
    );

    const cst = this.CSTIBSCBSCollection.find(
      (e) => e.codigo === this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime?.CST,
    );

    if (classTrib) {
      this.cClassTrib = classTrib;
    }

    if (cst) {
      this.cstIBSCBS = cst;
    }
  },
  methods: {
    changeClassTribIBSCBSSelected(selectedClassTribIBSCBS) {
      this.$emit('onChangeCClassTrib', selectedClassTribIBSCBS);

      if (selectedClassTribIBSCBS) {
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.cClassTrib =
          selectedClassTribIBSCBS.codigo;

        this.cClassTrib = {
          ...selectedClassTribIBSCBS,
        };

        const cstCode = selectedClassTribIBSCBS.codigo.substring(0, 3);

        const cst = this.CSTIBSCBSCollection.find((e) => e.codigo === cstCode);

        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CST = cst.codigo;

        this.cstIBSCBS = {
          ...cst,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.cClassTrib = null;
      this.cClassTrib = null;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CST = null;
      this.cstIBSCBS = null;
    },
  },
};
</script>
